@if (crossReferencesError()) {
  <ideal-error [error]="crossReferencesError()"></ideal-error>
} @else if (ready()) {
  <form class="cross-references" [formGroup]="crossReferencesForm">
    @for (xref of crossReferences(); track xref.customerNumber) {
      <div class="xref" [attr.data-save-status]="entryStatusFor(xref.customerNumber)()">
        <div class="label">
          <div class="customer-number">{{ xref.customerNumber }}</div>
          <div class="customer-name">{{ xref.customerName }}</div>
        </div>
        <div class="value">
          <ideal-text-input
            [formControlName]="xref.customerNumber"
            i18m-label="@@products.crossReferences.label"
            label="Cross References"
            i18n-placeholder="@@products.crossReferences.placeholder"
            placeholder="Enter your reference code here"
          >
          </ideal-text-input>
          <span class="save-status-indicator" [attr.aria-label]="entryStatusFor(xref.customerNumber)()">
            @switch (entryStatusFor(xref.customerNumber)()) {
              @case ("saving") {
                <span class="status-icon status-saving" aria-hidden="true"></span>
              }
              @case ("saved") {
                <span class="status-icon status-saved" aria-hidden="true"></span>
              }
              @case ("error") {
                <span class="status-icon status-error" aria-hidden="true"></span>
              }
            }
          </span>
        </div>
      </div>
    }
  </form>
}
